module.exports = __webpack_public_path__ + "img/weddingbox.28a4fe7.webp";